<template>
  <ul class="price-info">
    <li v-for="item in priceInfo" :key="item.label + item.value">
      <span :class="{ 'vertical-top': item.showIcon }">{{ item.label }}</span>
      <span v-if="item.showIcon" class="icon-box vertical-top" @click="togglePopState(item)">
        <div style="position: absolute; top: 3.5px">
          <van-icon class="pop-icon" size="14" :name="item.iconName" />
        </div>

        <div v-show="showPopLabel === item.label" class="pop-box">
          您的订单将被拆成多个包裹分开发货，现运费由平台承担。如有订单发货后，您仍需全部退款或分开退回，则需您自行承担退回运费，请您知晓。
        </div>
      </span>
      <span
        class="r"
        :style="{
          color: item.color
        }"
      >
        {{ item.value }}
      </span>
    </li>
  </ul>
</template>

<script >
export default {
  props: {
    priceInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPopLabel: ''
    };
  },
  methods: {
    togglePopState(item) {
      if (item.label === this.showPopLabel) {
        this.showPopLabel = '';
        return;
      }
      this.showPopLabel = item.label;
    }
  }
};
</script>

<style lang="less" scoped>
.price-info {
  padding: 7px 0;
  margin: 0 16px;
  li {
    height: 32px;
    font-size: @font-size-md;
    line-height: 16px;
    color: @gray-8;
    padding: 8px 0px;
  }
  .icon-box {
    display: inline-block;
    position: relative;
    width: 16px;
    height: 16px;
    margin-left: 4px;
    .pop-icon {
      font-weight: 500;
    }
  }
  .pop-box {
    position: absolute;
    z-index: 10;
    left: -7px;
    top: 23px;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 4px;
    box-shadow: 0px 0px 6px 0px rgba(38, 38, 38, 0.1);
    width: 220px;
    padding: 14px 12px;
    color: #ffffff;
    font-size: 14px;
    line-height: 23px;
    word-break: break-all;

    &::after {
      display: inline-block;
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px;
      border-color: transparent transparent rgba(0, 0, 0, 0.75) transparent;
      position: absolute;
      left: 9px;
      top: -10px;
    }
  }
}
</style>
